import(/* webpackMode: "eager" */ "/app/assets/images/icon/eye-open.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/icon/timer.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/placeholder/dummyImage.png");
;
import(/* webpackMode: "eager" */ "/app/assets/images/placeholder/player.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/placeholder/team.png");
;
import(/* webpackMode: "eager" */ "/app/assets/images/team-ic.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/accordian/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/breadcrumbNav/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/customLink/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/fantasyArticle/leagues/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/fantasyArticle/matchInfo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/fantasyArticle/probableEleven/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/fantasyArticle/seriesState/stats/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/fantasyArticle/topPicks/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/myImage/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/revive-ads/index.tsx");
